
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { SERVER_ORIGIN } from "../../utilities/constants";
import css from "../../css/admin/users-page.module.css";
import toast from "react-hot-toast";

function DownloadSchoolExcel({ endpoint = "/api/em/auth/institute/download-school-template", filename = "YUVA_SCHOOL_SHEET_SAMPLE.xlsx", children }) {
  const [xlDownloadBtn, setXlDownloadBtn] = useState(true);

  function handleDownload() {
    try {
      const token = sessionStorage.getItem("token");
      const userType = sessionStorage.getItem("userType");

      let downloadEndpoint = endpoint;
      if (endpoint === "/api/em/auth/institute/download-school-template" && (userType === 'admin' || userType === 'regionem')) {
        downloadEndpoint = "/api/admin/auth/institute/download-school-template";
      }

      fetch(`${SERVER_ORIGIN}${downloadEndpoint}`, {
        method: "GET",
        headers: {
          "auth-token": token,
        },
      })
        .then(async (response) => {
          if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            console.error("Download failed:", response.status, errorData);
            throw new Error(errorData?.statusText || `HTTP error! Status: ${response.status}`);
          }
          return response.blob();
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Download error:", error.message);
          toast.error(error.message || "Failed to download sample Excel file. Please try again.");
        });
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Failed to download sample Excel file");
    }

    setTimeout(() => {
      setXlDownloadBtn(false);
    }, 2000);
  }

  const renderButton = () => {
    if (children) {
      return React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            onClick: handleDownload,
          });
        }
        return child;
      });
    }

    return (
      <div className="xl-download-btn-wrapper">
        <button className={css.xlDownloadBtn} onClick={handleDownload}>
          <FontAwesomeIcon icon={faDownload} style={{ marginRight: "5px" }} />
          Download Sample Excel Format
        </button>
      </div>
    );
  };

  return <div>{xlDownloadBtn && renderButton()}</div>;
}

export default DownloadSchoolExcel;